import React from 'react';

const WorkPost = props => {
    const { permalink, thumb, title, category, categoryURL } = props.workData;

    return (
        <a href={"#popup-" + permalink} className={"workItem " + categoryURL}>
            <figure>
                <div className="workImg">
                    <img src={thumb} alt={title} />
                </div>
                <div className="workDetails">
                    <p className="projectCategory">{category}</p>
                    <h5 className="projectTitle">{title}</h5>
                </div>
            </figure>
        </a >
    );
};

export default WorkPost;